<template>
    <form
        method="post"
        @submit.prevent="submit"
        @keydown="clearErrors($event.target.name)"
    >
        <div
            v-show="form.succeeded"
            id="result"
            class="alert alert-success text-center"
        >
            {{ trans('lang_message.registered') }}
            <i class="fa fa-refresh fa-spin"></i>
            {{ trans('lang_message.entering') }}
        </div>
        <div
            class="form-group has-feedback"
            :class="{ 'has-error': form.errors.has('name') }"
        >
            <input
                v-model="form.name"
                type="text"
                class="form-control"
                :placeholder="trans('lang_message.fullname')"
                name="name"
                value=""
                autofocus
            />
            <span class="glyphicon glyphicon-user form-control-feedback"></span>
            <transition name="fade">
                <span
                    v-if="form.errors.has('name')"
                    class="help-block"
                    v-text="form.errors.get('name')"
                ></span>
            </transition>
        </div>
        <div
            class="form-group has-feedback"
            :class="{ 'has-error': form.errors.has('email') }"
        >
            <input
                v-model="form.email"
                type="email"
                class="form-control"
                :placeholder="trans('lang_message.email')"
                name="email"
                value=""
            />
            <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
            <transition name="fade">
                <span
                    v-if="form.errors.has('email')"
                    class="help-block"
                    v-text="form.errors.get('email')"
                ></span>
            </transition>
        </div>
        <div
            class="form-group has-feedback"
            :class="{ 'has-error': form.errors.has('password') }"
        >
            <input
                v-model="form.password"
                type="password"
                class="form-control"
                :placeholder="trans('lang_message.password')"
                name="password"
            />
            <span class="glyphicon glyphicon-lock form-control-feedback"></span>
            <transition name="fade">
                <span
                    v-if="form.errors.has('password')"
                    class="help-block"
                    v-text="form.errors.get('password')"
                ></span>
            </transition>
        </div>
        <div class="form-group has-feedback">
            <input
                v-model="form.password_confirmation"
                type="password"
                class="form-control"
                :placeholder="trans('lang_message.retypepassword')"
                name="password_confirmation"
            />
        </div>
        <div class="row">
            <div class="col-xs-7">
                <label>
                    <div class="checkbox_register icheck">
                        <label
                            data-toggle="modal"
                            data-target="#termsModal"
                        >
                            <input
                                v-model="form.terms"
                                type="checkbox"
                                name="terms"
                                class="has-error"
                            />
                            <a
                                href="#"
                                :class="{
                                    'text-danger': form.errors.has('terms'),
                                }"
                                v-text="trans('lang_message.conditions')"
                            ></a>
                        </label>
                    </div>
                </label>
            </div>
            <div class="col-xs-4 col-xs-push-1">
                <button
                    type="submit"
                    class="btn btn-primary btn-block btn-flat"
                    :disabled="form.errors.any()"
                >
                    <i
                        v-if="form.submitting"
                        class="fa fa-refresh fa-spin"
                    />
                    <span v-else>{{ trans('lang_message.register') }}</span>
                </button>
            </div>
        </div>
        <div
            v-if="form.errors.has('terms')"
            class="form-group has-feedback"
            :class="{ 'has-error': form.errors.has('terms') }"
        >
            <span
                v-if="form.errors.has('terms')"
                class="help-block"
                v-text="form.errors.get('terms')"
            ></span>
        </div>
    </form>
</template>

<script>
import Form from 'acacha-forms';
import initialitzeIcheck from './InitializeIcheck';
import redirect from './redirect';

export default {
    mixins: [initialitzeIcheck, redirect],
    data: function () {
        return {
            form: new Form({
                name: '',
                email: '',
                password: '',
                password_confirmation: '',
                terms: '',
            }),
        };
    },
    watch: {
        'form.terms': function (value) {
            if (value) {
                $('input').iCheck('check');
            } else {
                $('input').iCheck('uncheck');
            }
        },
    },
    mounted() {
        this.initialitzeICheck('terms');
    },
    methods: {
        submit() {
            this.form
                .post('/register')
                .then((response) => {
                    var component = this;
                    setTimeout(function () {
                        component.redirect(response);
                    }, 2500);
                })
                .catch((error) => {
                    console.log(this.trans('lang_message.registererror') + ':' + error);
                });
        },
        clearErrors(name) {
            if (name === 'password_confirmation') {
                name = 'password';
                this.form.errors.clear('password_confirmation');
            }
            this.form.errors.clear(name);
        },
    },
};
</script>

<style src="./fade.css"></style>
